export const environment = {
  production: true,
  platform: 'DTH',
  timezone: 'Brazil/East',
  validQualifiers: ['DJCTQ'],
  langFilters: ['pt','pt-br','en'],
  defaultLang: 'pt-br',
  apiUrl: 'https://3wkm18eo34.execute-api.us-west-2.amazonaws.com/api'
};